import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from '@/components/ui/pagination'
import { pageItems } from '@/ui/pager'

// 목록의 쪽을 옮기는 줄. 쪽이 하나뿐이어도 선다 — 목록이 한 쪽이라는 것도 목록의 크기다.
// `disabled` 는 쪽을 옮길 수 없는 동안이다(고른 줄에 일괄 조작이 도는 동안 — 고르기는 그 쪽의 것이다).
// `name` 은 랜드마크의 이름이다 — 다른 목록의 쪽 번호와 한 화면에 서면 부르는 쪽이 그 목록의 이름을 준다.
// 이름이 같으면 화면 읽기 도구가 둘을 가르지 못한다. 한 목록의 위아래 쪽 번호는 같은 이름이다.
export function Pager({
  page,
  pages,
  onPage,
  className,
  disabled = false,
  name = '페이지',
}: {
  page: number
  pages: number
  onPage: (page: number) => void
  className?: string
  disabled?: boolean
  name?: string
}) {
  return (
    <Pagination className={className} aria-label={name}>
      <PaginationContent>
        <PaginationItem>
          <PaginationPrevious disabled={disabled || page <= 1} onClick={() => onPage(page - 1)} />
        </PaginationItem>
        {pageItems(page, pages).map((item, at) =>
          item === 'gap' ? (
            <PaginationItem key={`gap-${at}`}>
              <PaginationEllipsis />
            </PaginationItem>
          ) : (
            <PaginationItem key={item}>
              <PaginationLink
                isActive={item === page}
                disabled={disabled}
                aria-label={`${item} 쪽`}
                className="text-[12px] tabular-nums"
                onClick={() => onPage(item)}
              >
                {item}
              </PaginationLink>
            </PaginationItem>
          ),
        )}
        <PaginationItem>
          <PaginationNext disabled={disabled || page >= pages} onClick={() => onPage(page + 1)} />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  )
}
